import ModalWrapper from '@Components/Modals/ModalWrapper/ModalWrapper';
import AssetTemplateServices from '@Services/AssetTemplate.services';
import { AssetTemplate } from '@Types/Asset.types';
import { handleRequestError } from '@Utils/request.utils';
import { ErrorDisplay, Toast } from '@kg-internal/pv3-uikit';
import { useState } from 'react';

type Props = {
  show: boolean;
  assetTemplate?: AssetTemplate;
  onClose: () => void;
  onSuccess: () => void;
};

const DeleteAssetTemplate = ({ show, assetTemplate, onClose, onSuccess }: Props) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

  const deleteAssetTemplate = () => {
    AssetTemplateServices.disableAssetTemplate(assetTemplate?.id)
      .then(() => {
        Toast.success('Asset template deleted successfully.');
        onSuccess();
        onClose();
      })
      .catch((errorResponse) => handleRequestError(errorResponse, setErrorMessage, true));
  };

  return (
    <div className='modal--fit-content modal--w-30vw modal--pt-25vh'>
      <ModalWrapper
        title='Delete Asset Template'
        show={show}
        handleClose={onClose}
        primaryButtonText='Confirm'
        primaryAction={() => deleteAssetTemplate()}>
        {errorMessage ? (
          <ErrorDisplay inline details={errorMessage} />
        ) : (
          <div>
            <p>
              <b>Name</b> : {assetTemplate?.name}
            </p>
            <br />
          </div>
        )}
      </ModalWrapper>
    </div>
  );
};

export default DeleteAssetTemplate;
